module.exports = __webpack_public_path__ + "static/media/bangkok_salmon_bowl.e44a1315.png";